import { all, call, fork, put, takeEvery } from 'redux-saga/effects'
import _ from 'lodash'
import { toast } from 'react-toastify'

import { getLastGeneratedPlan, postGeneratePlan } from 'services/apiMotorBgc'
import reportError from 'utils/errorReporter'
import { PANEL_ENVS } from 'utils/constants/environments'

import { selectApiKey, selectUserId } from 'redux/auth/saga.selectors'

import * as actions from './actions'

function* fetchPlanCpfLast() {
  yield takeEvery(actions.FETCH_PLAN_CPF_LAST, function* sg(_action) {
    const apiKey = yield selectApiKey()
    const userId = yield selectUserId()

    let resLastPlan = null
    try {
      resLastPlan = yield call(getLastGeneratedPlan, apiKey, userId, PANEL_ENVS.CPF)
    } catch (err) {
      const messageError = _.get(err, 'response.data.msg_errors.0.msg') || 'Erro ao obter o plano'
      yield put({ type: actions.FETCH_PLAN_CPF_LAST_FAILED, payload: messageError })

      reportError(err, messageError)
      return
    }

    const { plan_id, services, process_pole } = resLastPlan.data

    yield put({
      type: actions.FETCH_PLAN_CPF_LAST_SUCCEEDED,
      payload: {
        plan_id: plan_id,
        services: services,
        process_pole: process_pole,
      },
    })
  })
}

function* createPlanCpf() {
  yield takeEvery(actions.CREATE_PLAN_CPF, function* sg(action) {
    const { processPole, servicesChecked } = action.payload

    const apiKey = yield selectApiKey()
    const userId = yield selectUserId()

    let res = null
    try {
      res = yield call(postGeneratePlan, apiKey, userId, PANEL_ENVS.CPF, servicesChecked, processPole)
    } catch (err) {
      const messageError = _.get(err, 'response.data.msg_errors.0.msg') || 'Erro ao criar o plano'
      yield put({ type: actions.CREATE_PLAN_CPF_FAILED, payload: messageError })

      reportError(err, messageError)
      return
    }

    const { plan_id, services, process_pole } = res.data

    yield put({
      type: actions.CREATE_PLAN_CPF_SUCCEEDED,
      payload: {
        plan_id: plan_id,
        services: services,
        process_pole: process_pole,
      },
    })

    yield put(actions.fetchPlanCpfLast())

    toast.success('Plano atualizado com sucesso.')
  })
}

export default function* rootSaga() {
  yield all([
    fork(createPlanCpf),
    fork(fetchPlanCpfLast),
  ])
}
